/* Warning: please do not statically import any dependencies here except for static assets like icons */
import { NotificationIcon } from '@panwds/icons'
import { _T } from './i18n'

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ vars, sparkyFramework }: any) =>
  sparkyFramework.getFrameworkVar('use_new_left_nav') && {
    actions: [
      {
        key: 'announcements',
        title: _T('Announcements'),
        navComponent: () => import(/* webpackPreload: true */ './NavNotifications'),
        mapStateToProps: () => ({ vars }),
        icon: NotificationIcon,
        avail: () => true,
        callAvail: 'override',
        _override_existing: true,
      },
    ],
  }
